<template>
  <b-form class="col-md-12 px-0 page-section pt-0" @submit.prevent>
    <template v-if="showHeader">
      <h3 class="text-center mb-1">Nice pic! Now tell us where you're headed.</h3>
      <p class="text-center mb-5">Knowing your goals helps us point you to the programs and support that fit you.</p>
    </template>

    <b-form-group
      label="Are you interested in continuing your education?"
      label-for="continuing_education_interest"
      label-class="form-label"
    >
      <v-select
        id="continuing_education_interest"
        class="form-control v-select-custom"
        label="text"
        v-model="profile.continuing_education_interest"
        :reduce="item => item.value"
        placeholder="Select an option"
        :options="continuingEducationOptions"
      />
    </b-form-group>

    <template v-if="isContinuing">
      <b-form-group label="What career are you interested in pursuing?" label-for="career_goal" label-class="form-label">
        <v-select
          id="career_goal"
          class="form-control v-select-custom"
          label="text"
          v-model="profile.career_goal"
          :reduce="item => item.value"
          placeholder="Select a career"
          :options="careerGoalOptions"
        />
      </b-form-group>

      <b-form-group
        v-if="profile.career_goal === 'other'"
        label="Tell us which career"
        label-for="career_goal_other"
        label-class="form-label"
      >
        <b-form-input id="career_goal_other" v-model="profile.career_goal_other" placeholder="Enter the career" />
      </b-form-group>

      <b-form-group
        label="When are you hoping to take your next step?"
        label-for="career_goal_timeline"
        label-class="form-label"
      >
        <v-select
          id="career_goal_timeline"
          class="form-control v-select-custom"
          label="text"
          v-model="profile.career_goal_timeline"
          :reduce="item => item.value"
          placeholder="Select a timeline"
          :options="timelineOptions"
        />
      </b-form-group>

      <b-form-group
        label="Where are you currently in your journey?"
        label-for="career_pathway_stage"
        label-class="form-label"
      >
        <v-select
          id="career_pathway_stage"
          class="form-control v-select-custom"
          label="text"
          v-model="profile.career_pathway_stage"
          :reduce="item => item.value"
          placeholder="Select where you are"
          :options="pathwayStageOptions"
        />
      </b-form-group>

      <b-form-group
        label="What would you like help with? (Select all that apply)"
        label-for="career_support_needs"
        label-class="form-label"
      >
        <v-select
          id="career_support_needs"
          class="form-control v-select-custom"
          label="text"
          v-model="profile.career_support_needs"
          :reduce="item => item.value"
          placeholder="Select everything that applies"
          :options="supportNeedOptions"
          multiple
        />
      </b-form-group>
    </template>
  </b-form>
</template>

<script>
import { pick } from 'lodash';
import { CAREER_INTENT_OPTIONS } from '@/common/constants';

const CAREER_INTENT_FIELDS = [
  'continuing_education_interest',
  'career_goal',
  'career_goal_other',
  'career_goal_timeline',
  'career_pathway_stage',
  'career_support_needs',
];

export default {
  props: {
    profileData: { type: Object, required: true },
    showHeader: { type: Boolean, default: true },
  },

  data() {
    return {
      profile: {
        continuing_education_interest: null,
        career_goal: null,
        career_goal_other: null,
        career_goal_timeline: null,
        career_pathway_stage: null,
        career_support_needs: [],
      },

      continuingEducationOptions: CAREER_INTENT_OPTIONS.continuing_education_interest,
      careerGoalOptions: CAREER_INTENT_OPTIONS.career_goal,
      timelineOptions: CAREER_INTENT_OPTIONS.career_goal_timeline,
      pathwayStageOptions: CAREER_INTENT_OPTIONS.career_pathway_stage,
      supportNeedOptions: CAREER_INTENT_OPTIONS.career_support_needs,
    };
  },

  computed: {
    isContinuing() {
      return ['yes', 'maybe'].includes(this.profile.continuing_education_interest);
    },
    // Only the intent values, so edits to unrelated profile fields don't reset this form.
    incomingIntent() {
      return JSON.stringify(pick(this.profileData, CAREER_INTENT_FIELDS));
    },
  },

  watch: {
    incomingIntent: {
      handler() {
        const incoming = pick(this.profileData, CAREER_INTENT_FIELDS);
        this.profile = {
          ...this.profile,
          ...incoming,
          career_support_needs: incoming.career_support_needs || [],
        };
      },
      immediate: true,
    },
    // Hidden answers are cleared rather than saved invisibly.
    isContinuing(value) {
      if (!value) {
        this.profile = {
          ...this.profile,
          career_goal: null,
          career_goal_other: null,
          career_goal_timeline: null,
          career_pathway_stage: null,
          career_support_needs: [],
        };
      }
    },
    'profile.career_goal'(value) {
      if (value !== 'other') {
        this.profile.career_goal_other = null;
      }
    },
  },

  methods: {
    // Every question is optional, so the step never blocks progress.
    validateFormData() {
      return { isValid: true, formData: { ...this.profile } };
    },
  },
};
</script>
